export default __webpack_public_path__ + "static/media/emailLogo.b59a8800.svg";